export const queryKeys = {
  GET_MSG_SMSBOT: 'GET_MSG_SMSBOT',
  DELETE_MSG_SMSBOT: 'DELETE_MSG_SMSBOT'
};
